import Vue from 'vue'
import Router from 'vue-router'
const DefaultLayout = () => import('@/views/layout/default')
// const ScaleLayout = () => import('@/views/layout/scaleLayout')

Vue.use(Router)

export default new Router({
  routes: [
    { // 管理
      path: '/manage',
      component: DefaultLayout,
      meta: {requireAuth: true},
      children: [
        { path: 'endpoint', component: () => import('@/views/manage/endpoint') },
        { path: 'join', component: () => import('@/views/manage/joinTeam') },
        { path: 'operator', component: () => import('@/views/manage/operator/index') },
        { path: 'operator/bind', component: () => import('@/views/manage/operator/device/bind') },
        { path: 'operator/place', component: () => import('@/views/manage/operator/place/index') },
        { path: 'operator/place/add', component: () => import('@/views/manage/operator/place/placeAdd') },
        { path: 'operator/place/edit', component: () => import('@/views/manage/operator/place/placeEdit') },
        { path: 'operator/device', component: () => import('@/views/manage/operator/device/index') },
        { path: 'operator/device/bind', component: () => import('@/views/manage/operator/device/bind') },
        { path: 'operator/device/control', component: () => import('@/views/manage/operator/device/control') },
        { path: 'operator/device/params', component: () => import('@/views/manage/operator/device/paramsSet') },
        { path: 'operator/device/exception', component: () => import('@/views/manage/operator/device/exception') },
        { path: 'operator/device/shelf', component: () => import('@/views/manage/operator/device/shelfSet') },
        { path: 'operator/device/shelf/goods', component: () => import('@/views/manage/operator/device/shelfGoods') },
        { path: 'operator/device/shelf/stock', component: () => import('@/views/manage/operator/device/shelfStock') },
        { path: 'operator/device/shelf/price', component: () => import('@/views/manage/operator/device/shelfPrice') },
        { path: 'operator/order', component: () => import('@/views/manage/operator/order/index') },
        { path: 'operator/sales', component: () => import('@/views/manage/operator/sales/index') },
        { path: 'operator/sales/dayList', component: () => import('@/views/manage/operator/sales/dayList') },
        { path: 'operator/sales/monthList', component: () => import('@/views/manage/operator/sales/monthList') },
        { path: 'operator/sales/dayChart', component: () => import('@/views/manage/operator/sales/dayChart') },
        { path: 'operator/sales/monthChart', component: () => import('@/views/manage/operator/sales/monthChart') },
        { path: 'operator/cash', component: () => import('@/views/manage/operator/cash/index') },
        { path: 'operator/cash/cashlist', component: () => import('@/views/manage/operator/cash/cashlist') },
        { path: 'operator/cash/account', component: () => import('@/views/manage/operator/cash/cashAccount') },
        { path: 'operator/cash/cashapply', component: () => import('@/views/manage/operator/cash/cashApply') },
        { path: 'operator/transaction', component: () => import('@/views/manage/operator/transaction/index') },
        { path: 'operator/transaction/detail', component: () => import('@/views/manage/operator/transaction/detail') },
        { path: 'operator/account', component: () => import('@/views/manage/operator/account/index') },
        { path: 'operator/payment', component: () => import('@/views/manage/operator/payment/index') },
        { path: 'operator/payment/add', component: () => import('@/views/manage/operator/payment/add') },
        { path: 'operator/payment/log', component: () => import('@/views/manage/operator/payment/log') },
        { path: 'agent', component: () => import('@/views/manage/agent/index') },
        { path: 'agent/operator', redirect: { path: '/manage/common/team/subteam', query: {roleCode: 'operator'} } },
        { path: 'agent/device', component: () => import('@/views/manage/agent/device/index') },
        { path: 'agent/account', component: () => import('@/views/manage/agent/account/index') },
        { path: 'platform', component: () => import('@/views/manage/platform/index') },
        { path: 'platform/agent', redirect: { path: '/manage/common/team/subteam', query: {roleCode: 'agent'} } },
        { path: 'platform/devicetype', component: () => import('@/views/manage/platform/device/type') },
        { path: 'platform/device', component: () => import('@/views/manage/platform/null') },
        { path: 'platform/device/list', component: () => import('@/views/manage/platform/device/list') },
        { path: 'platform/device/control', component: () => import('@/views/manage/platform/device/control') },
        { path: 'platform/device/mockexp', component: () => import('@/views/manage/platform/device/mockexp') },
        { path: 'platform/transaction', component: () => import('@/views/manage/platform/transaction/index') },
        { path: 'platform/showbuy', component: () => import('@/views/manage/platform/null') },
        { path: 'platform/bill', component: () => import('@/views/manage/platform/null') },
        { path: 'platform/order', component: () => import('@/views/manage/platform/null') },
        { path: 'platform/finance', component: () => import('@/views/manage/platform/null') },
        { path: 'platform/upgrade', component: () => import('@/views/manage/platform/null') },
        { path: 'platform/account', component: () => import('@/views/manage/platform/account/index') },
        { path: 'platform/member/list', component: () => import('@/views/manage/platform/member/list') },
        { path: 'store', component: () => import('@/views/manage/store/index') },
        { path: 'store/account', component: () => import('@/views/manage/store/account/index') },
        { path: 'common/team/subteam', component: () => import('@/views/manage/common/team/subTeam') },
        { path: 'common/team/subteamadd', component: () => import('@/views/manage/common/team/subTeamAdd') },
        { path: 'common/team/subteammember', component: () => import('@/views/manage/common/team/subTeamMember') },
        { path: 'common/team/subteammember/detail', component: () => import('@/views/manage/common/team/subMemberDetail') },
        { path: 'common/team/invitemember', component: () => import('@/views/manage/common/team/inviteMember') },
        { path: 'common/team/myteammember', component: () => import('@/views/manage/common/team/myTeamMember') },
        { path: 'common/team/myteammember/detail', component: () => import('@/views/manage/common/team/memberDetail') },
        { path: 'common/team/myteaminfo', component: () => import('@/views/manage/common/team/myTeamInfo') }
      ]
    },
    { // 支付
      path: '/pay',
      component: DefaultLayout,
      children: [
        { path: 'qr', component: () => import('@/views/pay/qr') }
      ]
    },
    { // 扫码抽奖
      path: '/lottery',
      component: DefaultLayout,
      children: [
        { path: 'giftscan', component: () => import('@/views/lottery/index') }
      ]
    },
    { // 扫码抽奖
      path: '/freepick',
      component: DefaultLayout,
      children: [
        { path: 'config', component: () => import('@/views/freepick/config') },
        { path: 'plandetail', component: () => import('@/views/freepick/planDetail') }
      ]
    },
    { // 首页
      path: '/',
      component: DefaultLayout,
      meta: {requireAuth: true},
      children: [
        { path: '', redirect: { path: '/mycenter' } },
        { path: 'home', redirect: { path: '/mycenter' } }
      ]
    },
    { // 在线买盒
      path: '/buygift',
      component: DefaultLayout,
      children: [
        { path: '', component: () => import('@/views/buygift/niudan') },
        { path: 'confirm', component: () => import('@/views/buygift/orderConfirm') },
        { path: 'address', component: () => import('@/views/buygift/address') },
        { path: 'orderresult', component: () => import('@/views/buygift/orderResult') }
      ]
    },
    { // 晒单领奖
      path: '/showbuy',
      component: DefaultLayout,
      children: [
        { path: '', component: () => import('@/views/showbuy/index') },
        { path: 'publish', component: () => import('@/views/showbuy/publish') }
      ]
    },
    { // 每日签到
      path: '/signin',
      component: DefaultLayout,
      children: [
        { path: '', component: () => import('@/views/signin/main') }
      ]
    },
    { // 个人中心
      path: '/mycenter',
      component: DefaultLayout,
      children: [
        { path: '', component: () => import('@/views/mycenter/index') },
        { path: 'bindphone', component: () => import('@/views/mycenter/bindphone') }
      ]
    },
    { // 字母卡
      path: '/lettercard',
      component: DefaultLayout,
      children: [
        { path: 'list', component: () => import('@/views/lettercard/list') },
        { path: 'dujiang', component: () => import('@/views/lettercard/dujiang') },
        { path: 'detail', component: () => import('@/views/lettercard/detail') }
      ]
    },
    { // 收货地址
      path: '/address',
      component: DefaultLayout,
      children: [
        { path: 'list', component: () => import('@/views/address/list') },
        { path: 'add', component: () => import('@/views/address/add') },
        { path: 'edit', component: () => import('@/views/address/edit') }
      ]
    },
    { // 订单管理
      path: '/order',
      component: DefaultLayout,
      children: [
        { path: 'list', component: () => import('@/views/order/list') },
        { path: 'detail', component: () => import('@/views/order/detail') },
        { path: 'pay', component: () => import('@/views/order/pay') }
      ]
    },

    { // 我的积分
      path: '/integral',
      component: DefaultLayout,
      children: [
        { path: 'list', component: () => import('@/views/integral/list') },
        { path: 'lottery', component: () => import('@/views/integral/lottery') }
      ]
    },
    { // 我的奖品
      path: '/prize',
      component: DefaultLayout,
      children: [
        { path: 'list', component: () => import('@/views/prize/list') },
        { path: 'submitcontact', component: () => import('@/views/prize/submitContact') }
      ]
    },
    { // 门店优惠券
      path: '/storecoupon',
      component: DefaultLayout,
      children: [
        { path: 'pick', component: () => import('@/views/storecoupon/pick') },
        { path: 'mycoupon', component: () => import('@/views/storecoupon/mycoupon') },
        { path: 'mycoupon/forStoreList', component: () => import('@/views/storecoupon/forStoreList') },
        { path: 'storeAdd', component: () => import('@/views/storecoupon/storeAdd') },
        { path: 'storeEdit', component: () => import('@/views/storecoupon/storeEdit') },
        { path: 'storeList', component: () => import('@/views/storecoupon/storeList') },
        { path: 'use', component: () => import('@/views/storecoupon/use') },
        { path: 'howView', component: () => import('@/views/storecoupon/howView') },
        { path: 'useLog', component: () => import('@/views/storecoupon/useLog') },
        { path: 'useLogStoreList', component: () => import('@/views/storecoupon/useLogStoreList') }
      ]
    },
    {
      path: '/public',
      component: {template: '<router-view/>'},
      meta: {requireAuth: false},
      children: [
        {path: 'document/preview', component: () => import('@/views/public/document/preview')},
        {path: '*', component: () => import('@/views/404'), meta: {keepAlive: true}}
      ]
    },
    {
      path: '/applyaccount',
      component: DefaultLayout, // component: {template: '<router-view/>'},
      children: [
        { path: 'cn', redirect: { path: '/applyaccount/index', query: {lang: 'cn'} } },
        { path: 'en', redirect: { path: '/applyaccount/index', query: {lang: 'en'} } },
        { path: 'index', component: () => import('@/views/applyaccount/index') }
      ]
    },
    {
      path: '/test',
      component: DefaultLayout, // component: {template: '<router-view/>'},
      children: [
        { path: '', component: () => import('@/views/Test') }
      ]
    },
    {
      path: '/403',
      component: DefaultLayout, // component: {template: '<router-view/>'},
      children: [
        { path: '', component: () => import('@/views/403') }
      ]
    },
    {
      path: '/404',
      component: () => import('@/views/404'),
      meta: { keepAlive: true } // keepAlive-需要被缓存
    },
    {
      path: '*',
      redirect: { path: '/404' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js